import ActionTypes from './actions';
import {
  InitialStateType, THandleChangeSearch, THandleChangeInfoBooking, TypeForDialog,
} from './index';


type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined ? { type: Key } : { type: Key, payload: M[Key] }
}

type CommonPayload = {
  [ActionTypes.HANDLE_CHANGE]: {
    name: string,
    value: InitialStateType[keyof InitialStateType],
  },
  [ActionTypes.HANDLE_CHANGE_SEARCH]: THandleChangeSearch,

  [ActionTypes.HANDLE_CHANGE_INFO_BOOKING]: THandleChangeInfoBooking,

  [ActionTypes.HANDLE_RESET_CONTEXT]: InitialStateType,

  [ActionTypes.DISPLAY_DIALOG]: {
    typeDialog: keyof typeof TypeForDialog;
  },
  [ActionTypes.HIDE_DIALOG]: undefined
}


type CommonActions = ActionMap<CommonPayload>[keyof CommonPayload];

type ActionsReducer = CommonActions;

const reducerBooking = (state: InitialStateType, action: ActionsReducer) => {
  switch (action.type) {
    case ActionTypes.HANDLE_CHANGE: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    }

    case ActionTypes.HANDLE_CHANGE_SEARCH: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case ActionTypes.HANDLE_CHANGE_INFO_BOOKING: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case ActionTypes.HANDLE_RESET_CONTEXT: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case ActionTypes.DISPLAY_DIALOG: {
      return {
        ...state,
        isDialogOpen: true,
        typeDialog: action.payload.typeDialog,
      };
    }

    case ActionTypes.HIDE_DIALOG: {
      return {
        ...state,
        isDialogOpen: false,
      };
    }
    default:
      return state;
  }
};

export default reducerBooking;
